var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"0ac80487832e531a1f06d01e13bc72e2935952c1"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["app-headlinker@martinratinaud"]={id:"0ac80487832e531a1f06d01e13bc72e2935952c1"};
      